module.exports = __webpack_public_path__ + "static/media/UMC.28e679b1.png";